module.exports = __webpack_public_path__ + "img/sp-act.0ce00f5e.png";